module.exports = __webpack_public_path__ + "img/help-circle.25827158.svg";